export var AppGroup;
(function (AppGroup) {
    /** default empty value. */
    AppGroup["EMPTY"] = "EMPTY";
    /** app is installed. */
    AppGroup["INSTALLED"] = "INSTALLED";
    /** app is pending to be added to stage in the editor. */
    AppGroup["PENDING"] = "PENDING";
    /** the app is a Wix business solution. */
    AppGroup["BUSINESS_SOLUTIONS"] = "BUSINESS_SOLUTIONS";
    /** app was installed from a bundle. */
    AppGroup["BUNDLE"] = "BUNDLE";
})(AppGroup || (AppGroup = {}));
export var BundleAppOrigin;
(function (BundleAppOrigin) {
    BundleAppOrigin["UNKNOWN"] = "UNKNOWN";
    BundleAppOrigin["SILENT_PROVISION"] = "SILENT_PROVISION";
    BundleAppOrigin["COUPON"] = "COUPON";
})(BundleAppOrigin || (BundleAppOrigin = {}));
//# sourceMappingURL=types.impl.js.map